import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../Interface';

const PartnerSettingFields = ({ viewField, autoCompleteOptions, formData }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          name="defCompanyShippingAddr"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Alap. szállítási cím megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defCompanyShippingAddr} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defCompanyShippingAddr && values.defCompanyShippingAddr !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          name="defCompanyBillingAddr"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Alap. számlázási cím megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defCompanyBillingAddr} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defCompanyBillingAddr && values.defCompanyBillingAddr !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="autocomplete"
          name="defCompanyCountry"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Alap. cím ország" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defCompanyCountry} />}
          onChange={(_e, newVal) => {
            setFieldValue('defCompanyCountry', newVal?.value ?? null).then(() => {
              validateField('defCompanyCountry');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defCompanyCountry !== '' }}
          selectedValue={values.defCompanyCountry}
          selectedLabelValue={formData?.companyCountry?.name}
          dataset={autoCompleteOptions.country}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="autocomplete"
          name="defCompanyCustomerGroup"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Alap. vevő csoport" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defCompanyCustomerGroup} />}
          onChange={(_e, newVal) => {
            setFieldValue('defCompanyCustomerGroup', newVal?.value ?? null).then(() => {
              validateField('defCompanyCustomerGroup');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defCompanyCustomerGroup !== '' }}
          selectedValue={values.defCompanyCustomerGroup}
          selectedLabelValue={formData?.companyCustomerGroup?.name}
          dataset={autoCompleteOptions.customerGroup}
        />
      </div>
    </div>
  );
};

export default PartnerSettingFields;
